module.exports = __webpack_public_path__ + "fontello.2df6f5916eabe06678d8.eot";


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/global-assets/fonts/font/fontello.eot?57799508
// module id = ../../../../../src/app/global-assets/fonts/font/fontello.eot?57799508
// module chunks = main